export enum EntityTypeEnum {
  PROFESSIONAL = 'PROFESSIONAL',
  CLINIC = 'CLINIC',
  LABORATORY_COLLECT_POINT = 'LABORATORY_COLLECT_POINT',
  BRANCH = 'BRANCH',
}
